import { TimeLineBubbleIds } from './constants';

export enum TimelinePositions {
  LEFT = 'left',
  MIDDLE = 'middle',
  RIGHT = 'right',
  CLOSE_RIGHT = 'close-right',
}

export type TimelineBubbleType = {
  id: TimeLineBubbleIds;
  value: number | string;
  position: TimelinePositions;
  fillColor: string;
  secondaryColor?: string;
  strokeColor: string;
  textColor: string;
  hasOpacity?: boolean;
  isValueBottom?: boolean;
  tooltip?: string;
};

export type TimeLineGraphDataType = {
  labels: {
    header: {
      title: string;
      value: string;
      subtitle: string;
    };
    footer: {
      title: string;
      value: string;
      subtitle: string;
    };
  };
  bubbles: TimelineBubbleType[];
  minValue?: number;
  maxValue?: number;
};

export interface TimeLineGraphProps {
  data: TimeLineGraphDataType;
  width?: number;
  height?: number;
  className?: string;
  onBubbleClick?: (bubble: TimelineBubbleType) => void;
  onBubbleHover?: (bubble: TimelineBubbleType) => void;
}
